// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"28":"9f89fabe","615":"d19c4c8a","723":"17dad2f7","879":"c6d4b167"}[chunkId] + ".chunk.css";
};